import React from 'react'
import Aux from '../../../hoc/Auxiliary'
import SectionHeading from '../../../components/Heading'

export const ContentRU = () => {
    return <Aux>
        <SectionHeading priority={1} text='Материалы' />
        <p><b>Балконные двери и окна - REHAU GENEO</b> – ЭТО ЛУЧШЕЕ, НА КОТОРОЕ КАЖДЫЙ МОЖЕТ НАДЕЯТЬСЯ!</p>
        <p>GENEO лидирует в строительстве престижной недвижимости. Система эта запатентована REHAU с применением новой технологии, когда средняя камера профилей экструдирована (отливка на матрице) из высокотехнологического материала RAU-FIPRO. Этот высокотехнологический материал впервые использовали в самолетостроении и в Формуле 1, а теперь уже в окнах и балконных дверях.<br />
        GENEO лидирует среди 86-миллиметровых систем! Это лучшая комбинация 7-камерных рам с 6-камерными створками и вдоль встроенными, резиновыми уплотнителями посередине.<br />
        Тройной стеклопакет: 4 мм.ка +4 мм.белое + 4мм.четыре сезона 42 мм.<br />
        Стеклопакеты заливают двухкомпонентным полисульфидом Кемерлинг- Германия<br />
        Оригинальное Расширение 45/80 Synego за каждой створкой со стороны петлей – Подготовка для установки внутренних жалюзи.</p>
        <p><b>Фурнитура</b> - <i>activPilot</i> - последнее поколение фурнитурной системы Winkhaus, сочетающая современный дизайн и высокую функциональность.</p>
        <p><b>Дръжки</b> – модел разработен  от Пининфарина, прочутият дизайнер.</p>
        <p><b>Тухли</b> – Porotherm на Wienerberger.<br />
        Это традиционный материал, но он отвечает современным требованиям. Теплоизоляция и гидроизоляция - высшего сорта.</p>
        <p><b>Парапеты</b> - ударопрочное ламинированное стекло</p>
        <p><b>Внешние двери</b> - высокое качество входных дверей – блиндированные</p>
    </Aux>
}

export default ContentRU



// WEBPACK FOOTER //
// ./src/routes/Materials/components/ContentRU.js